import { AfterViewInit, Component, ElementRef, OnDestroy, ViewChild, ViewEncapsulation } from '@angular/core';
import { IonicSlides } from '@ionic/angular';
import Swiper from 'swiper';

import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import * as StrategyActions from '@strategy/strategy.actions';

@Component({
  encapsulation: ViewEncapsulation.None,
  selector: 'app-strategy-intro',
  styleUrls: ['./strategy-intro.component.scss'],
  templateUrl: './strategy-intro.component.html',
  standalone: false
})
export class StrategyIntroComponent implements AfterViewInit, OnDestroy {
  @ViewChild('swiperContainer', { static: false }) swiperContainer?: ElementRef<{ swiper: Swiper }>;
  private slideChangeHandler?: (swiper: Swiper) => void;
  swiperModules = [IonicSlides];
  isLoading$: Observable<boolean>;
  currentSlideIndex = 0;
  slides = [
    {
      imageSrc: '/assets/images/onboarding-intro-slide-1.png',
      imageAlt: 'Child watching windmills',
      heading: 'investIntro.slide1.heading',
      paragraph: 'investIntro.slide1.paragraph',
      cta: 'investIntro.slide1.cta',
      alignImageRight: false
    },
    {
      imageSrc: '/assets/images/onboarding-intro-slide-2.png',
      imageAlt: 'Hand touching water surface',
      heading: 'investIntro.slide2.heading',
      paragraph: 'investIntro.slide2.paragraph',
      cta: 'investIntro.slide2.cta',
      alignImageRight: true
    },
    {
      imageSrc: '/assets/images/onboarding-intro-slide-3.png',
      imageAlt: 'Teenager planting a tree',
      heading: 'investIntro.slide3.heading',
      paragraph: 'investIntro.slide3.paragraph',
      cta: 'investIntro.slide3.cta',
      alignImageRight: true
    }
  ];

  constructor(private store: Store) {}

  ngAfterViewInit(): void {
    if (this.swiperContainer && this.swiperContainer.nativeElement?.swiper) {
      this.slideChangeHandler = (swiper: Swiper) => this.onSlideChange(swiper);
      this.swiperContainer.nativeElement.swiper.on('slideChange', this.slideChangeHandler);
    }
  }

  onSlideChange(swiper: Swiper): void {
    this.currentSlideIndex = swiper.activeIndex;
  }

  goToNextSlide(): void {
    if (this.swiperContainer && this.swiperContainer.nativeElement?.swiper) {
      this.swiperContainer.nativeElement.swiper.slideNext();
    }
  }

  proceedToNextQLStep(): void {
    this.store.dispatch(StrategyActions.updateQLOnboardingStep({ step: 2 }));
  }

  ngOnDestroy(): void {
    if (this.swiperContainer && this.swiperContainer.nativeElement?.swiper && this.slideChangeHandler) {
      this.swiperContainer.nativeElement.swiper.off('slideChange', this.slideChangeHandler);
    }
  }
}
